// Copyright (c) 2025 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import TimestampUser from '@deere/cps-it.warranty-model-factory/lib/timestamp-user';
import {buildTransferAllDealerRecommendationPayload} from '../services/dealer-recommendation-helper';
import {closeDealerRecommendationModal} from './dealer-recommendation-modal';
import {resetSelectedDealerRecommendations} from './dealer-recommendation';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {transferAllDealerRecom} from '../../shared/repositories';
import {translate} from '../../../shared/services/translation-service';
import {updateTransferResultsWithFacets} from './facet-updates';

export const transferAllDealerRecommendation = commentsDealerRecommendation =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const facetsDlrRecomm = getState().dealerRecommendationsReducer.facets;

        const requestedBy = new TimestampUser({
            firstName: getState().user.details.firstName,
            id: getState().user.details.id,
            lastName: getState().user.details.lastName
        });

        const status = 'NEW';

        const dealerRecommendationPayload = buildTransferAllDealerRecommendationPayload(facetsDlrRecomm, requestedBy, commentsDealerRecommendation, status);

        try {

            await transferAllDealerRecom(dealerRecommendationPayload);

            successAlertBar(translate('DEALER_TRANSFER_REQUEST_SUCCESSFULLY'));

        } catch (error) {

            throw error;

        } finally {

            dispatch(closeDealerRecommendationModal());
            dispatch(updateTransferResultsWithFacets(false, 0));
            dispatch(resetSelectedDealerRecommendations());
            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/transfer-all-dealer-recommendation.js